<template>
  <v-row no-gutters>
    <v-col cols="" style="min-width: 0">
      <v-slide-group show-arrows class="ml-1 my-1">
        <v-slide-group-item v-for="(menuEntry, index) in filteredMenuItems" :key="menuEntry.text">
          <navigation-menu-item
            :menu-item="menuEntry"
            :is-selected="currentFocusIndex === index"
            class="mr-1"
            :tabindex="index === 0 ? 0 : -1"
            @keydown.right="focusNext(index)"
            @keydown.left="focusPrevious(index)"
            @blur="currentFocusIndex = null"
            @focus="currentFocusIndex = index"
          />
        </v-slide-group-item>
      </v-slide-group>
    </v-col>
    <v-col cols="auto" class="d-flex justify-end align-center">
      <toolbar-product-comparison class="my-1 ml-1" />
      <toolbar-shopping-cart class="ma-1" />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { MenuItem } from '@/components/navigation/menu'
import NavigationMenuItem from '@/components/navigation/NavigationMenuItem.vue'
import ToolbarProductComparison from '@/components/toolbar/ToolbarProductComparison.vue'
import ToolbarShoppingCart from '@/components/toolbar/ToolbarShoppingCart.vue'
import { filterMenuItems } from '@/helpers'
import { PortalSettings } from '@/modules/portalSettings/types'
import { computed, PropType, ref } from 'vue'

const props = defineProps({
  menu: {
    type: Array as PropType<MenuItem[]>,
    default: () => []
  },
  portalSettings: {
    type: Object as PropType<PortalSettings>,
    required: true
  }
})

const currentFocusIndex = ref<number | null>(null)
const filteredMenuItems = computed(() => {
  return filterMenuItems(props.menu, props.portalSettings)
})

const focusNext = (currentIndex: number) => {
  const nextIndex = (currentIndex + 1) % filteredMenuItems.value.length
  currentFocusIndex.value = nextIndex
}

const focusPrevious = (currentIndex: number) => {
  const previousIndex =
    (currentIndex - 1 + filteredMenuItems.value.length) % filteredMenuItems.value.length
  currentFocusIndex.value = previousIndex
}
</script>
